import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultApiConfig } from "./apiSettings";
import { FeedPerformanceData } from "./feedPerformance.types";

export const feedPerformanceApi = createApi({
  ...defaultApiConfig,
  reducerPath: "feedPerformanceApi",
  tagTypes: ["FeedPerformance"],
  endpoints: (builder) => ({
    getFeedPerformance: builder.query<{ data: FeedPerformanceData }, void>({
      query: () => "admin/feed-performance",
      providesTags: ["FeedPerformance"],
    }),
  }),
});

export const { useGetFeedPerformanceQuery } = feedPerformanceApi;
